import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LibChartComponent } from './chart.component';



@NgModule({
  declarations: [
    LibChartComponent
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    LibChartComponent
  ]
})
export class LibChartModule { }
